module.exports = __webpack_public_path__ + "media/images/bank_images/banco_pine-420b4e3dc38ae3e9bdda160381f8f40a.png";